import React, { useEffect, useRef } from 'react';
import { shallow } from '@jwp/ott-common/src/utils/compare';
import type { Content } from '@jwp/ott-common/types/config';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import { useTranslation } from 'react-i18next';
import { useContentStateStore } from '@jwp/ott-common/src/stores/ContentStateStore';
import { useNavigationStack } from '@jwp/ott-common/src/stores/NavigationStackStore';

import ShelfList from '../../containers/ShelfList/ShelfList';

import '../../styles/accessibility.scss';

const Home = () => {
  const { config } = useConfigStore(({ config, accessModel }) => ({ config, accessModel }), shallow);
  const content: Content[] = config?.content;
  const { t } = useTranslation('common');
  const pageId = 'home';

  const pageState = useContentStateStore((s) => s.pages[pageId]);
  const setPageState = useContentStateStore((s) => s.setPageState);

  const { setAncestor, reset } = useNavigationStack();

  const restoredRef = useRef(false);

  useEffect(() => {
    if (!restoredRef.current && pageState?.scrollPosition) {
      window.scrollTo(0, pageState.scrollPosition);
      restoredRef.current = true;
    }

    const handleScroll = () => {
      setPageState(pageId, { scrollPosition: window.scrollY, from: 'Home' });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pageId, pageState?.scrollPosition, setPageState]);

  useEffect(() => {
    reset();
    setAncestor('/');
  }, []);
  useContentStateStore.setState({ click: { label: 'Home', contentId: '' } });
  useContentStateStore.setState({ activeScreen: 'Home' });
  const filteredContent = content?.filter((item) => {
    const supportedPlatforms = item?.custom?.supportedPlatforms;
    if (!supportedPlatforms) return true;

    return supportedPlatforms
      .split(',')
      .map((platform: string) => platform.trim().toLowerCase())
      .includes('web');
  });

  return (
    <>
      <h1 className="hideUntilFocus">{t('home')}</h1>
      <ShelfList rows={filteredContent} />
    </>
  );
};

export default Home;
